module.exports = __webpack_public_path__ + "assets/img/charges-calc.859a5c32.png";